import PropTypes from 'prop-types';
import Critere from './Critere.js';

const CritereList = ({ criteres, onUpdateValue, onRemove }) => (
  <div className="criteres">
    {criteres.map((critere) => (
      <Critere
        critere={critere}
        key={critere.id}
        onUpdateValue={onUpdateValue}
        onRemove={onRemove}
      />
    ))}
  </div>
);
CritereList.propTypes = {
  criteres: PropTypes.array.isRequired,
  onRemove: PropTypes.func.isRequired,
  onUpdateValue: PropTypes.func.isRequired,
};

export default CritereList;
